import { ScoreDefinitionDTO } from 'business/models/Models';
import EAutoScoreType from 'enums/EAutoScoreType';
import { scorePercentagesEnum } from './constants';

export const getScoreToolTip = (wellDropScore, score: ScoreDefinitionDTO) => {
  if (score) {
    const toolTipParts = [];

    const scoreType = score.isAutoScore ? score.scoreGroupName : 'Manual Score';
    const scoreValue =
      wellDropScore.autoScoreType === EAutoScoreType.FRAP
        ? wellDropScore?.autoScoreValue?.toFixed(2)
        : score.scoreName;
    toolTipParts.push(`${scoreType}: ${scoreValue}`);

    if (wellDropScore.scoreDetails?.length) {
      wellDropScore.scoreDetails.forEach((scoreDetail) => {
        const percentage = Math.round(parseFloat(scoreDetail.value) * 100);
        const character = scorePercentagesEnum.getCharacter(scoreDetail.item);
        toolTipParts.push(`${character}: ${percentage}%`);
      });
    }

    if (wellDropScore.morphologyDetails?.length) {
      toolTipParts.push('\nMorphology:');
      wellDropScore.morphologyDetails.forEach((morphologyDetail) => {
        const percentage = Math.round(parseFloat(morphologyDetail.value) * 100);
        const character = scorePercentagesEnum.getCharacter(morphologyDetail.item);
        toolTipParts.push(`${character}: ${percentage}%`);
      });
    }

    return toolTipParts.join('\n');
  } else if (wellDropScore.isUVIndicator) {
    switch (wellDropScore.scoreName) {
      case '+':
        return `${wellDropScore.scoreGroupName}: Positive Hit`;
      case '-':
        return `${wellDropScore.scoreGroupName}: Negative Hit`;
      default:
        return `${wellDropScore.scoreGroupName}: ${wellDropScore.scoreName}`;
    }
  }
};
